import { useParams } from "react-router-dom";
import BroadcastSettingsView from "./../components/BroadcastSettingsView.react";


export default function BroadcastSettingsViewRoute(): React$Element<any> {
  let params = useParams();
  return <BroadcastSettingsView sessionId={params.sessionId} />;
}
